import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { disconnectGithub } from '@/services/git/api';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useDisconnectGithub(): UseMutationResult<void, Error, void> {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useMutation({
    mutationFn: () => disconnectGithub(orgId!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gitConnection', orgId] });
      queryClient.invalidateQueries({ queryKey: ['gitRepos', orgId] });
      queryClient.invalidateQueries({ queryKey: ['gitSelectedRepo', orgId] });
    },
  });
}
